<template>
    <v-app app id="app">
        <head>
            <title>Real Deal </title>
            <meta name="viewport" content="width=device-width, initial-scale=1.0">
            <meta name="robots" content="index" />
            <meta http-equiv="Content-Type" content="text/html; charset=utf-8" />
            <meta name="description"
                content="The Date Night Business Portal aims to expand the online presence of community based businesses, introduce singles/groups to their new favorite place, and create a network of potential partners for local events." />
        </head>
        <business-nav v-if="isAuthenticated && !isBusinessPage"></business-nav>
        <public-nav v-else-if="!isAuthenticated && !isBusinessPage"></public-nav>

        <v-main fluid v-if="!isBusinessPage">
            <template>
                <router-view></router-view>
            </template>
        </v-main>
        <router-view v-else></router-view>

        <v-snackbar top :value="showSnackBar">
            {{ snackBarText }}
        </v-snackbar>
        <payment-dialog :showDialog="showPaymentDialog" :charges="sessionCharges"
            @set-dialog-control="setPaymentDialogControl"></payment-dialog>
        <v-footer id="app-footer" border class="px-6 py-3">
            <v-row dense no-gutters>
                <v-btn variant="text" class="mx-2" :rounded="true">
                    Legal
                </v-btn>
                <v-btn variant="text" class="mx-2" :rounded="true">
                    About
                </v-btn>
                <v-col class="center" cols="12">
                    {{ new Date().getFullYear() }} — Real Deal
                </v-col>
            </v-row>
        </v-footer>
    </v-app>
</template>

<script>
import './plugins/google-maps';
import BusinessNav from './components/navigation/BusinessNavigation'
import PublicNav from './components/navigation/PublicNav'
import PaymentDialog from './components/common/PaymentDialog';
import { MongoMixins } from './mixins/mongo-mixins';

export default {
    name: 'App',
    components: {
        'business-nav': BusinessNav,
        'public-nav': PublicNav,
        'payment-dialog': PaymentDialog
    },
    mixins: [MongoMixins],
    data: () => ({
        rail: false,
        drawer: true
    }),
    created() {
        this.$store.dispatch('VERIFY_TOKEN');
    },
    methods: {
        setPaymentDialogControl(val) {
            const dispatchString = val ? 'SHOW_PAYMENT_DIALOG' : 'HIDE_PAYMENT_DIALOG';
            this.$store.dispatch(dispatchString);
        },
        toggleRail() {
            this.rail = !this.rail;
            console.log(this.rail);
        }
    },
    computed: {
        isAuthenticated() {
            return this.$store.getters.isAuthenticated;
        },
        isBusinessPage() {
            console.log(window.location.href.startsWith(`${process.env.VUE_APP_DATENIGHT_SITE_URL}/business-page/`));
            return window.location.href.startsWith(`${process.env.VUE_APP_DATENIGHT_SITE_URL}/business-page/`)
        },
        isContractor() {
            return this.$store.state.isContractor;
        },
        sessionCharges() {
            return this.$store.state.sessionCharges;
        },
        cartCount() {
            return (this.$store.state.sessionCharges || []).length;
        },
        showSnackBar() {
            return this.$store.state.snackbar;
        },
        snackBarText() {
            return this.$store.state.snackbarText;
        },
        showPaymentDialog() {
            return this.$store.state.paymentDialog;
        },
        cookieExpiry() {
            return this.$store.getters.refreshTime;
        },
        leftChevron() {
            return require('./assets/Chevron-Left.svg');
        }
    },
}
</script>

<style lang="scss">
@import './styles/styles.scss';

#app {
    background: radial-gradient(ellipse at right bottom, $app-bar-secondary 10%, $app-bar-primary 33%, $app-bar-black 100%);
    font-family: Avenir, Helvetica, Arial, sans-serif;
    -webkit-font-smoothing: antialiased;
    -moz-osx-font-smoothing: grayscale;
    text-align: center;
    color: #2c3e50;
}

.row {
    margin: 0 !important;
}
</style>
